import { isRegistrationSessionKey } from "./registrationDraft";
import { isNewContractRequest, verificationNext } from "./verification";

/** Return to the same amount draft without trusting arbitrary return URLs or keys. */
export function verificationRequestContext(value: unknown) {
  const next = verificationNext(value);
  const request = isNewContractRequest(next);
  const params = new URL(next, window.location.origin).searchParams;
  const key = params.get("session_key");
  const sessionKey = request && isRegistrationSessionKey(key) ? key : null;
  return {
    next,
    request,
    amountEntry: sessionKey !== null && params.get("entry") === "amount",
    backPath: sessionKey === null ? "/start" : `/registration?session_key=${encodeURIComponent(sessionKey)}`,
  };
}
